/**
 * 全局提示
 *
 * @file global-hint.js
 * @author yangwei(yangwei14@baidu.com)
 */

import {Component} from 'san';
import './global-hint.less';

export default class extends Component {

    static template = `
        <template>
            <div class="global-hint-container" >
                <div class="hint-content">
                    <img src="{{img}}" alt="img" s-if="img">
                    <div class="hint-message">
                        <slot/>
                    </div>
                </div>
            </div>
        </template>
    `;
}
